var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgObjectDetectionNodeSvg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10.322 9.89",
    height: 37.381,
    width: 39.011
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.265
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.607 3.422l7.661-2.246-3.013 4.471z",
    fill: "#909090",
    stroke: "#909090",
    strokeWidth: 0.22094110000000003
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.899 9.212l-.63-8.036-3.014 4.471z",
    fill: "#212121",
    stroke: "#212121",
    strokeWidth: 0.22094110000000003
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#212121",
    strokeWidth: 1.411,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.268.268h1.654M.268 1.922V.268M10.053.268v1.654M8.4.268h1.653",
    strokeWidth: 0.52913911
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.053 9.622H8.4M10.053 7.968v1.654",
    strokeWidth: 0.52913911
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M.268 9.622V7.968M1.922 9.622H.268",
    strokeWidth: 0.52913911
  }))))));
}
export default SvgObjectDetectionNodeSvg;